import { render, staticRenderFns } from "./AirwayButtons.vue?vue&type=template&id=2e246227&scoped=true&"
import script from "./AirwayButtons.vue?vue&type=script&lang=js&"
export * from "./AirwayButtons.vue?vue&type=script&lang=js&"
import style0 from "./AirwayButtons.vue?vue&type=style&index=0&id=2e246227&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e246227",
  null
  
)

export default component.exports